import { handleActions } from "redux-actions";
import actionCreators from "../../actions/communities/manager_recruitments";

const initialState = {
  managerRecruitmentDetail: {},
  prefList: [],
  cityList: [],
  myCircleList: [],
  modalIsOpen: false,
  createStatus: "",
  createdCircleId: 0,
};

export default handleActions(
  {
    [actionCreators.communities.managerRecruitments.success]: (state, action) =>
      Object.assign({}, state, action.payload.data),
    [actionCreators.communities.managerRecruitments.failure]: (state, action) =>
      Object.assign({}, state, action.payload.data),
  },
  initialState
);
